module.exports = __webpack_public_path__ + "img/no_events.15ae407b.svg";